import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const tripViolations = createAsyncThunk(
    "trip/tripViolations",
    async ({ data, params }, { rejectWithValue }) => {
        try {
            const response = await apiService.tripViolations(data, params);
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to get trip violations");
        }
    }
);

// =======================================================

export const createFuelLog = createAsyncThunk(
    "fuel/createFuelLog",
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.createFuelLog(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to create fuel log");
        }
    }
);

export const getFuelStations = createAsyncThunk(
    "fuel/getFuelStations",
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getFuelStations();
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to get fuel stations");
        }
    }
);

export const getTripListsDropdown = createAsyncThunk(
    "fuel/getTripListsDropdown",
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getTripListsDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to get trip lists dropdown");
        }
    }
);

export const fetchFuelOverview = createAsyncThunk(
    "fuel/fetchFuelOverview",
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.overviewFuel();
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to fetch fuel overview");
        }
    }
);

export const fuelLogsLists = createAsyncThunk(
    "fuel/fuelLogsLists",
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.fuelLogsLists(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to get fuel logs lists");
        }
    }
);

export const getFuelLogDetails = createAsyncThunk(
    "fuel/getFuelLogDetails",
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.fuelDetails(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to get fuel log details");
        }
    }
);

export const fuelGeneralDetails = createAsyncThunk(
    "fuel/fuelGeneralDetails",
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.fuelGeneralDetails(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to get fuel general details");
        }
    }
);

export const deleteFuelLogs = createAsyncThunk(
    "fuel/deleteFuelLogs",
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.deleteFuelLogs(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to delete fuel logs");
        }
    }
);

export const uploadedFuelFiles = createAsyncThunk(
    "fuel/uploadedFuelFiles",
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.uploadedFuelFiles(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to upload fuel files");
        }
    }
);

export const updateFuelFinanceStatus = createAsyncThunk(
    "fuel/updateFuelFinanceStatus",
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updateFuelFinanceStatus(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to update fuel finance status");
        }
    }
);

// ======================= VEHICLE LOGS ======================

export const getVehiclePaginated = createAsyncThunk(
    "fuel/getVehiclePaginated",
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.getVehiclePaginated(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to get vehicle paginated");
        }
    }
);

export const getVehicleDetails = createAsyncThunk(
    "fuel/getVehicleDetails",
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.getVehicleDetails(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to get vehicle details");
        }
    }
);

export const getVehicleDetailsByFuelLog = createAsyncThunk(
    "fuel/getVehicleDetailsByFuelLog",
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.getVehicleDetailsByFuelLog(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to get vehicle details by fuel log");
        }
    }
);

export const deleteVehicle = createAsyncThunk(
    "fuel/deleteVehicle",
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.deleteVehicle(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to delete vehicle");
        }
    }
);

export const getRefuelingHistoryByVehicle = createAsyncThunk(
    "fuel/getRefuelingHistoryByVehicle",
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.getRefuelingHistoryByVehicle(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to get refueling history by vehicle");
        }
    }
);

export const getVehicleHistory = createAsyncThunk(
    "fuel/getVehicleHistory",
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.getVehicleHistory(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to get vehicle history");
        }
    }
);

export const commentOnVehicle = createAsyncThunk(
    "fuel/commentOnVehicle",
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.commentOnVehicle(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || "Failed to comment on vehicle");
        }
    }
);

const initialState = {
    data: [],

    // ========================== FUEL ==========================

    createFuelLogData: [],
    createFuelLogLoading: false,
    createFuelLogError: null,

    getFuelStationsData: [],
    getFuelStationsLoading: false,
    getFuelStationsError: null,

    getTripListsDropdownData: [],
    getTripListsDropdownLoading: false,

    fetchFuelOverviewData: [],
    fetchFuelOverviewLoading: false,

    fuelLogsListsData: [],
    fuelLogsListsLoading: false,

    getFuelLogDetailsData: [],
    getFuelLogDetailsLoading: false,

    fuelGeneralDetailsData: [],
    fuelGeneralDetailsLoading: false,

    deleteFuelLogsData: [],
    deleteFuelLogsLoading: false,
    deleteFuelLogsError: null,

    uploadedFuelFilesData: [],
    uploadedFuelFilesLoading: false,
    uploadedFuelFilesError: null,

    updateFuelFinanceStatusData: [],
    updateFuelFinanceStatusLoading: false,
    updateFuelFinanceStatusError: null,

    // ========================== VEHICLE ==========================

    getVehiclePaginatedData: [],
    getVehiclePaginatedLoading: false,
    getVehiclePaginatedError: null,

    getVehicleDetailsData: [],
    getVehicleDetailsLoading: false,
    getVehicleDetailsError: null,

    getVehicleDetailsByFuelLogData: [],
    getVehicleDetailsByFuelLogLoading: false,
    getVehicleDetailsByFuelLogError: null,

    deleteVehicleData: [],
    deleteVehicleLoading: false,
    deleteVehicleError: null,

    getRefuelingHistoryByVehicleData: [],
    getRefuelingHistoryByVehicleLoading: false,
    getRefuelingHistoryByVehicleError: null,

    getVehicleHistoryData: [],
    getVehicleHistoryLoading: false,
    getVehicleHistoryError: null,

    commentOnVehicleData: [],
    commentOnVehicleLoading: false,
    commentOnVehicleError: null,

    tripViolationsData: [],
    tripViolationsLoading: false,
    tripViolationsError: null,

    updateLoading: false,
    loading: false,
    timelineLoading: false,
    error: null,
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    selectedTripId: null,
    viewAllTrips: false,
    activeTab: "fuel",
};

const fuelSlice = createSlice({
    name: "fuel",
    initialState,
    reducers: {
        setActiveTab: (state, action) => {
            state.activeTab = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
        setSelectedTripId: (state, action) => {
            state.selectedTripId = action.payload;
        },
        setViewAllTrips: (state, action) => {
            state.viewAllTrips = action.payload;
        },
        updateTripLiveData: (state, action) => {
            const { vehicle_id, lat, lng, speed, covered_distance, last_updated_at } =
                action.payload;

            const trip = state.tripListsData.find((t) => t.vehicle_id === vehicle_id);

            if (!trip) return;

            trip.covered_distance = Number(covered_distance) || 0;
            trip.last_updated_at = last_updated_at;

            if (!trip.trip_current_detail) {
                trip.trip_current_detail = {};
            }

            trip.trip_current_detail.lat = lat;
            trip.trip_current_detail.lng = lng;
            trip.trip_current_detail.speed = speed;
        },
        updateTripDetailsLiveData: (state, action) => {
            const { trip_id, lat, lng, speed } = action.payload;
            if (!state.tripDetailsData) return;
            if (state.tripDetailsData.id !== trip_id) return;
            if (!state.tripDetailsData.trip_current_detail) {
                state.tripDetailsData.trip_current_detail = {};
            }
            if (lat !== undefined)
                state.tripDetailsData.trip_current_detail.lat = lat;
            if (lng !== undefined)
                state.tripDetailsData.trip_current_detail.lng = lng;
            if (speed !== undefined)
                state.tripDetailsData.trip_current_detail.speed = speed;
        },
    },
    extraReducers: (builder) => {
        builder

            .addCase(fuelLogsLists.pending, (state) => {
                state.fuelLogsListsLoading = true;
            })
            .addCase(fuelLogsLists.fulfilled, (state, action) => {
                state.fuelLogsListsLoading = false;
                state.fuelLogsListsData = action?.payload?.data?.results;
            })
            .addCase(fuelLogsLists.rejected, (state, action) => {
                state.fuelLogsListsLoading = false;
            })

            .addCase(getFuelLogDetails.pending, (state) => {
                state.getFuelLogDetailsLoading = true;
            })
            .addCase(getFuelLogDetails.fulfilled, (state, action) => {
                state.getFuelLogDetailsLoading = false;
                state.getFuelLogDetailsData = action?.payload?.data;
            })
            .addCase(getFuelLogDetails.rejected, (state, action) => {
                state.getFuelLogDetailsLoading = false;
            })

            .addCase(fuelGeneralDetails.pending, (state) => {
                state.fuelGeneralDetailsLoading = true;
            })
            .addCase(fuelGeneralDetails.fulfilled, (state, action) => {
                state.fuelGeneralDetailsLoading = false;
                state.fuelGeneralDetailsData = action?.payload?.data;
            })
            .addCase(fuelGeneralDetails.rejected, (state, action) => {
                state.fuelGeneralDetailsLoading = false;
            })

            .addCase(fetchFuelOverview.pending, (state) => {
                state.fetchFuelOverviewLoading = true;
            })
            .addCase(fetchFuelOverview.fulfilled, (state, action) => {
                state.fetchFuelOverviewLoading = false;
                state.fetchFuelOverviewData = action?.payload?.data;
            })
            .addCase(fetchFuelOverview.rejected, (state, action) => {
                state.fetchFuelOverviewLoading = false;
            })

            .addCase(createFuelLog.pending, (state) => {
                state.createFuelLogLoading = true;
                state.createFuelLogError = null;
            })
            .addCase(createFuelLog.fulfilled, (state, action) => {
                state.createFuelLogLoading = false;
                state.createFuelLogData = action.payload;
                state.createFuelLogError = null;
            })
            .addCase(createFuelLog.rejected, (state, action) => {
                state.createFuelLogLoading = false;
                state.createFuelLogError = action.payload;
                state.createFuelLogData = [];
            })

            .addCase(getFuelStations.pending, (state) => {
                state.getFuelStationsLoading = true;
                state.getFuelStationsError = null;
            })
            .addCase(getFuelStations.fulfilled, (state, action) => {
                state.getFuelStationsLoading = false;
                state.getFuelStationsData = action?.payload?.data;
                state.getFuelStationsError = null;
            })
            .addCase(getFuelStations.rejected, (state, action) => {
                state.getFuelStationsLoading = false;
                state.getFuelStationsError = action.payload;
                state.getFuelStationsData = [];
            })

            .addCase(getTripListsDropdown.pending, (state) => {
                state.getTripListsDropdownLoading = true;
            })
            .addCase(getTripListsDropdown.fulfilled, (state, action) => {
                state.getTripListsDropdownLoading = false;
                state.getTripListsDropdownData = action?.payload?.data;
            })
            .addCase(getTripListsDropdown.rejected, (state, action) => {
                state.getTripListsDropdownLoading = false;
                state.getTripListsDropdownData = [];
            })

            .addCase(deleteFuelLogs.pending, (state) => {
                state.deleteFuelLogsLoading = true;
                state.deleteFuelLogsError = null;
            })
            .addCase(deleteFuelLogs.fulfilled, (state, action) => {
                state.deleteFuelLogsLoading = false;
                state.deleteFuelLogsData = action?.payload?.data;
                state.deleteFuelLogsError = null;
            })
            .addCase(deleteFuelLogs.rejected, (state, action) => {
                state.deleteFuelLogsLoading = false;
                state.deleteFuelLogsError = action.payload;
                state.deleteFuelLogsData = [];
            })

            .addCase(uploadedFuelFiles.pending, (state) => {
                state.uploadedFuelFilesLoading = true;
                state.uploadedFuelFilesError = null;
            })
            .addCase(uploadedFuelFiles.fulfilled, (state, action) => {
                state.uploadedFuelFilesLoading = false;
                state.uploadedFuelFilesData = action?.payload?.data;
                state.uploadedFuelFilesError = null;
            })
            .addCase(uploadedFuelFiles.rejected, (state, action) => {
                state.uploadedFuelFilesLoading = false;
                state.uploadedFuelFilesError = action.payload;
                state.uploadedFuelFilesData = [];
            })

            .addCase(updateFuelFinanceStatus.pending, (state) => {
                state.updateFuelFinanceStatusLoading = true;
                state.updateFuelFinanceStatusError = null;
            })
            .addCase(updateFuelFinanceStatus.fulfilled, (state, action) => {
                state.updateFuelFinanceStatusLoading = false;
                state.updateFuelFinanceStatusData = action?.payload?.data;
                state.updateFuelFinanceStatusError = null;
            })
            .addCase(updateFuelFinanceStatus.rejected, (state, action) => {
                state.updateFuelFinanceStatusLoading = false;
                state.updateFuelFinanceStatusError = action.payload;
                state.updateFuelFinanceStatusData = [];
            })

            // =================================================

            .addCase(getVehiclePaginated.pending, (state) => {
                state.getVehiclePaginatedLoading = true;
                state.getVehiclePaginatedError = null;
            })
            .addCase(getVehiclePaginated.fulfilled, (state, action) => {
                state.getVehiclePaginatedLoading = false;
                state.getVehiclePaginatedData = action?.payload?.data;
                state.getVehiclePaginatedError = null;
            })
            .addCase(getVehiclePaginated.rejected, (state, action) => {
                state.getVehiclePaginatedLoading = false;
                state.getVehiclePaginatedError = action.payload;
                state.getVehiclePaginatedData = [];
            })

            .addCase(getVehicleDetails.pending, (state) => {
                state.getVehicleDetailsLoading = true;
                state.getVehicleDetailsError = null;
            })
            .addCase(getVehicleDetails.fulfilled, (state, action) => {
                state.getVehicleDetailsLoading = false;
                state.getVehicleDetailsData = action?.payload?.data;
                state.getVehicleDetailsError = null;
            })
            .addCase(getVehicleDetails.rejected, (state, action) => {
                state.getVehicleDetailsLoading = false;
                state.getVehicleDetailsError = action.payload;
                state.getVehicleDetailsData = [];
            })

            .addCase(getVehicleDetailsByFuelLog.pending, (state) => {
                state.getVehicleDetailsByFuelLogLoading = true;
                state.getVehicleDetailsByFuelLogError = null;
            })
            .addCase(getVehicleDetailsByFuelLog.fulfilled, (state, action) => {
                state.getVehicleDetailsByFuelLogLoading = false;
                state.getVehicleDetailsByFuelLogData = action?.payload?.data;
                state.getVehicleDetailsByFuelLogError = null;
            })
            .addCase(getVehicleDetailsByFuelLog.rejected, (state, action) => {
                state.getVehicleDetailsByFuelLogLoading = false;
                state.getVehicleDetailsByFuelLogError = action.payload;
                state.getVehicleDetailsByFuelLogData = [];
            })

            .addCase(deleteVehicle.pending, (state) => {
                state.deleteVehicleLoading = true;
                state.deleteVehicleError = null;
            })
            .addCase(deleteVehicle.fulfilled, (state, action) => {
                state.deleteVehicleLoading = false;
                state.deleteVehicleData = action?.payload?.data;
                state.deleteVehicleError = null;
            })
            .addCase(deleteVehicle.rejected, (state, action) => {
                state.deleteVehicleLoading = false;
                state.deleteVehicleError = action.payload;
                state.deleteVehicleData = [];
            })

            .addCase(getRefuelingHistoryByVehicle.pending, (state) => {
                state.getRefuelingHistoryByVehicleLoading = true;
                state.getRefuelingHistoryByVehicleError = null;
            })
            .addCase(getRefuelingHistoryByVehicle.fulfilled, (state, action) => {
                state.getRefuelingHistoryByVehicleLoading = false;
                state.getRefuelingHistoryByVehicleData = action?.payload?.data;
                state.getRefuelingHistoryByVehicleError = null;
            })
            .addCase(getRefuelingHistoryByVehicle.rejected, (state, action) => {
                state.getRefuelingHistoryByVehicleLoading = false;
                state.getRefuelingHistoryByVehicleError = action.payload;
                state.getRefuelingHistoryByVehicleData = [];
            })

            .addCase(getVehicleHistory.pending, (state) => {
                state.getVehicleHistoryLoading = true;
                state.getVehicleHistoryError = null;
            })
            .addCase(getVehicleHistory.fulfilled, (state, action) => {
                state.getVehicleHistoryLoading = false;
                state.getVehicleHistoryData = action?.payload?.data;
                state.getVehicleHistoryError = null;
            })
            .addCase(getVehicleHistory.rejected, (state, action) => {
                state.getVehicleHistoryLoading = false;
                state.getVehicleHistoryError = action.payload;
                state.getVehicleHistoryData = [];
            })

            .addCase(commentOnVehicle.pending, (state) => {
                state.commentOnVehicleLoading = true;
                state.commentOnVehicleError = null;
            })
            .addCase(commentOnVehicle.fulfilled, (state, action) => {
                state.commentOnVehicleLoading = false;
                state.commentOnVehicleData = action?.payload?.data;
                state.commentOnVehicleError = null;
            })
            .addCase(commentOnVehicle.rejected, (state, action) => {
                state.commentOnVehicleLoading = false;
                state.commentOnVehicleError = action.payload;
                state.commentOnVehicleData = [];
            })

            .addCase(tripViolations.pending, (state) => {
                state.tripViolationsLoading = true;
                state.error = null;
            })
            .addCase(tripViolations.fulfilled, (state, action) => {
                state.tripViolationsLoading = false;
                state.tripViolationsData = action.payload?.data;
                state.error = null;
            })
            .addCase(tripViolations.rejected, (state, action) => {
                state.tripViolationsLoading = false;
                state.error = action.payload;
                state.tripViolationsData = [];
            })
    },
});

export const {
    setCurrentPage,
    clearError,
    setSelectedTripId,
    updateTripLiveData,
    updateTripDetailsLiveData,
    setViewAllTrips,
    setActiveTab,
} = fuelSlice.actions;

export default fuelSlice.reducer;
